import { render, staticRenderFns } from "./TtsAudioElementSettings.vue?vue&type=template&id=5d5336b5&scoped=true&"
import script from "./TtsAudioElementSettings.vue?vue&type=script&lang=ts&"
export * from "./TtsAudioElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5336b5",
  null
  
)

export default component.exports